// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coming-soon {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem;
  margin-top: 2rem;
  text-align: center;
}

.coming-soon-content {
  max-width: 600px;
  background: white;
  padding: 4rem 3rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.launching-badge {
  display: inline-block;
  background: #4CAF50;
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 50px;
  font-weight: 600;
  margin-bottom: 2rem;
  font-size: 1.2rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.coming-soon h1 {
  color: #2c3e50;
  margin: 0 0 1.5rem 0;
  font-size: 2.8rem;
  line-height: 1.2;
  font-weight: 700;
}

.coming-soon p {
  color: #5d6d7e;
  font-size: 1.3rem;
  margin: 0 0 3rem 0;
  line-height: 1.6;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.back-home {
  display: inline-block;
  margin-top: 1rem;
  color: #3498db;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  padding: 0.8rem 1.5rem;
  border: 2px solid #3498db;
  border-radius: 50px;
  background: transparent;
  cursor: pointer;
}

.back-home:hover {
  background: #3498db;
  color: white;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .coming-soon-content {
    padding: 3.5rem 2.5rem;
  }

  .coming-soon h1 {
    font-size: 2.5rem;
  }

  .coming-soon p {
    font-size: 1.2rem;
  }
}

@media (max-width: 768px) {
  .coming-soon {
    padding: 1.5rem;
  }
  
  .coming-soon-content {
    padding: 3rem 2rem;
  }
  
  .coming-soon h1 {
    font-size: 2.2rem;
  }
  
  .coming-soon p {
    font-size: 1.1rem;
    max-width: 100%;
  }
  
  .launching-badge {
    font-size: 1rem;
    padding: 0.6rem 1.5rem;
  }

  .back-home {
    font-size: 1rem;
    padding: 0.7rem 1.25rem;
  }
}

@media (max-width: 480px) {
  .coming-soon {
    padding: 1rem;
    margin-top: 1rem;
  }

  .coming-soon-content {
    padding: 2.5rem 1.5rem;
    border-radius: 16px;
  }

  .launching-badge {
    font-size: 0.875rem;
    padding: 0.5rem 1.25rem;
    margin-bottom: 1.5rem;
  }

  .coming-soon h1 {
    font-size: 1.875rem;
    margin-bottom: 1.25rem;
  }

  .coming-soon p {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .back-home {
    font-size: 0.9375rem;
    padding: 0.625rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ComingSoon.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;AACF","sourcesContent":[".coming-soon {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 2rem;\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.coming-soon-content {\n  max-width: 600px;\n  background: white;\n  padding: 4rem 3rem;\n  border-radius: 20px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n  animation: fadeIn 0.5s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.launching-badge {\n  display: inline-block;\n  background: #4CAF50;\n  color: white;\n  padding: 0.8rem 2rem;\n  border-radius: 50px;\n  font-weight: 600;\n  margin-bottom: 2rem;\n  font-size: 1.2rem;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);\n}\n\n.coming-soon h1 {\n  color: #2c3e50;\n  margin: 0 0 1.5rem 0;\n  font-size: 2.8rem;\n  line-height: 1.2;\n  font-weight: 700;\n}\n\n.coming-soon p {\n  color: #5d6d7e;\n  font-size: 1.3rem;\n  margin: 0 0 3rem 0;\n  line-height: 1.6;\n  max-width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.back-home {\n  display: inline-block;\n  margin-top: 1rem;\n  color: #3498db;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  padding: 0.8rem 1.5rem;\n  border: 2px solid #3498db;\n  border-radius: 50px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.back-home:hover {\n  background: #3498db;\n  color: white;\n  text-decoration: none;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .coming-soon-content {\n    padding: 3.5rem 2.5rem;\n  }\n\n  .coming-soon h1 {\n    font-size: 2.5rem;\n  }\n\n  .coming-soon p {\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .coming-soon {\n    padding: 1.5rem;\n  }\n  \n  .coming-soon-content {\n    padding: 3rem 2rem;\n  }\n  \n  .coming-soon h1 {\n    font-size: 2.2rem;\n  }\n  \n  .coming-soon p {\n    font-size: 1.1rem;\n    max-width: 100%;\n  }\n  \n  .launching-badge {\n    font-size: 1rem;\n    padding: 0.6rem 1.5rem;\n  }\n\n  .back-home {\n    font-size: 1rem;\n    padding: 0.7rem 1.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .coming-soon {\n    padding: 1rem;\n    margin-top: 1rem;\n  }\n\n  .coming-soon-content {\n    padding: 2.5rem 1.5rem;\n    border-radius: 16px;\n  }\n\n  .launching-badge {\n    font-size: 0.875rem;\n    padding: 0.5rem 1.25rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .coming-soon h1 {\n    font-size: 1.875rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .coming-soon p {\n    font-size: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .back-home {\n    font-size: 0.9375rem;\n    padding: 0.625rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
